module.exports = __webpack_public_path__ + "static/retail-ee4c8407c5fb6962514527ca90a824e0.svg";